import React, { useEffect } from "react";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export const InputDate = (props) => {
  const { label, id, value, onChange, isRequired, isError, displayType } =
    props;

  useEffect(() => {}, [value]);

  const handleDateChange = (newValue) => {
    // Extract the date part without time
    const dateWithoutTime = dayjs(newValue).format("YYYY-MM-DD");
    // Pass the date to the onChange function
    onChange(dateWithoutTime);
  };

  return (
    <div style={{ display: displayType }}>
      <label>
        {label}
        {isRequired && (
          <label
            style={{ color: "red", fontWeight: "bolder", fontSize: "18px" }}
          >
            * {displayType !== "grid" && " "}
          </label>
        )}
      </label>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={dayjs(value)}
          variant="outlined"
          slotProps={{ textField: { size: "small", error: isError } }}
          id={id}
          onChange={handleDateChange} // Use the modified onChange function
          required={isRequired}
          error={isError}
        />
      </LocalizationProvider>
    </div>
  );
};
